import _ from "lodash";

export default {
  getToken(state) {
    return state.token;
  },
  getUser(state) {
    return state.user;
  },
  getInfobarStatus(state) {
    return state.infobarStatus;
  },
  getTempData(state) {
    return state.tempData;
  }
};
